import { Alert, Button, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { HINT_SEVERITY_MAP } from '../utils/hintEngine';

/**
 * Componente de Dica Contextual
 * Exibe dicas inteligentes baseadas no contexto da página
 * 
 * @param {object} hint - Objeto com { type, icon, message, action: { label, link } }
 * @param {function} onActionClick - Callback quando não há link (ex: abrir modal)
 */
export default function ContextualHint({ hint, onActionClick = null }) {
  const navigate = useNavigate();

  if (!hint) {
    return null;
  }

  const severity = HINT_SEVERITY_MAP[hint.type] || 'info';

  const handleActionClick = () => {
    if (hint.action?.link) {
      // Navegar para outra página
      navigate(hint.action.link);
    } else if (onActionClick) {
      // Executar callback (ex: abrir modal)
      onActionClick();
    }
  };

  return (
    <Alert 
      severity={severity}
      sx={{ 
        borderRadius: 2,
        mb: 3,
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 2,
        }
      }}
    >
      <Box sx={{ flex: 1, display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        {hint.icon && (
          <Typography 
            component="span" 
            sx={{ 
              fontSize: '1.5rem', 
              lineHeight: 1,
              mt: 0.5,
              flexShrink: 0
            }}
          >
            {hint.icon}
          </Typography>
        )}
        <Typography variant="body1" sx={{ fontWeight: 500, flex: 1 }}>
          {hint.message}
        </Typography>
      </Box>
      
      {hint.action && (
        <Button
          variant="contained"
          size="small"
          onClick={handleActionClick}
          sx={{ 
            whiteSpace: 'nowrap',
            bgcolor: severity === 'success' ? 'success.main' : 'primary.main',
            '&:hover': {
              bgcolor: severity === 'success' ? 'success.dark' : 'primary.dark',
            }
          }}
        >
          {hint.action.label}
        </Button>
      )}
    </Alert>
  );
}
